var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.infos.length > 0)?_c('ul',{staticClass:"event-infos"},_vm._l((_vm.infos),function(info,index){return _c('li',{key:index},[(info.info.length > 0)?_c('span',[_vm._v(" "+_vm._s(info.info)+" ")]):_vm._e()])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }